/**
 * SplashScreenDemo Component
 *
 * Temporary demo page to showcase the splash screen in isolation
 */

import { useState, useEffect } from 'react'
import SplashScreen from './SplashScreen'

export default function SplashScreenDemo() {
  const [progress, setProgress] = useState(0)
  const [stage, setStage] = useState('farm')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Simulate loading progression - slower for better visibility
    const stages = ['farm', 'products', 'customers', 'branches', 'complete']
    let currentStageIndex = 0
    let currentProgress = 0

    const interval = setInterval(() => {
      currentProgress += Math.random() * 15
      if (currentProgress > 100) currentProgress = 100

      setProgress(currentProgress)

      if (currentProgress >= (currentStageIndex + 1) * 20 && currentStageIndex < stages.length - 1) {
        currentStageIndex++
        setStage(stages[currentStageIndex])
      }

      if (currentProgress >= 100) {
        // Keep splash visible for 3 more seconds after loading
        setTimeout(() => {
          setIsLoading(false)
        }, 3000)
        clearInterval(interval)
      }
    }, 800)

    return () => clearInterval(interval)
  }, [])

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <SplashScreen
        isLoading={isLoading}
        progress={progress}
        stage={stage}
      />
    </div>
  )
}
